import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CButton,
    CCard,
    CCardContent, CCircularProgress,
    CContainer,
    CFormControl, CGrid,
    CGridContainer, CH3,
    CInput,
    CInputAdornment, CInputLabel,
    CTextField
} from "../../components";
import loginIllustration from "../../assets/login.svg"
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {CIconButton} from "../../components/mui-extracted/icon-button";
import {useNavigate} from "react-router-dom";
import {useStores} from "../../models";
import {cast} from "mobx-state-tree";
import {useState} from "react";
import {isEmpty} from "validate.js";
import {hasValue} from "../../utils/empty-check";
import {Staff} from "../../models/staff/staff";

export const Login = observer(
    function Login() {

        const {authStore, businessStore, projectStore} = useStores()

        const [showPassword, setShowPassword] = React.useState<boolean>(false);

        const navigate = useNavigate();


        const [formData, setFormData] = useState({
            email: "",
            password: ""
        })

        const [formDataValidationMessages, setFormDataValidationMessages] = useState({
            email: "",
            password: ""
        })

        const [isSubmitting, setIsSubmitting] = useState(false)

        const isValid = () => {

            let output = true

            const currentFormDataValidationMessages = {
                ...formDataValidationMessages
            }

            if (isEmpty(formData.email)) {
                currentFormDataValidationMessages.email = "Email is required."
                output = false
            }

            if (isEmpty(formData.password)) {
                currentFormDataValidationMessages.password = "Password is required."
                output = false
            }

            if (!output) {
                setFormDataValidationMessages(currentFormDataValidationMessages)
            }

            return output
        }

        const submit = async () => {
            if (isValid()) {
                setIsSubmitting(true)

                const staff = await authStore.authenticateStaff(cast(formData));

                if(staff !== null) {
                    await businessStore.getBusiness(staff.businessId)
                    const projects = await projectStore.getProjects(staff.businessId, staff as Staff)
                    if(projects === null || projects.length === 0) {
                        navigate('/project-setup')
                    } else {
                        navigate('/panel')
                    }
                } else {
                    alert("Something went wrong! Please try again.")
                }
                setIsSubmitting(false)
            }
        }

        return (
            <>
                <main style={{minHeight: '100vh'}}>
                    <CContainer
                        style={{display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
                        <CCard>
                            <CCardContent sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                                <CGrid item xs={12}>
                                    <CH3 sx={(theme) => ({
                                        fontWeight: 900,
                                        mb: 2,
                                        color: theme.palette.primary.light
                                    })}>
                                        Welcome!
                                    </CH3>
                                </CGrid>
                                <CTextField
                                    error={hasValue(formDataValidationMessages.email)}
                                    helperText={formDataValidationMessages.email}
                                    label="Email"
                                    variant="standard"
                                    sx={{
                                        mb: 2
                                    }}
                                    value={formData.email}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setFormData({
                                            ...formData,
                                            email: event.target.value.trim()
                                        });
                                    }}
                                />
                                <CFormControl
                                    error={hasValue(formDataValidationMessages.password)}
                                    sx={{
                                        mb: 4,
                                        width: 320
                                    }} variant="standard">


                                    <CInputLabel htmlFor="login-password">
                                        Password
                                    </CInputLabel>
                                    <CInput
                                        id="login-password"
                                        type={showPassword ? 'text' : 'password'}
                                        value={formData.password}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setFormData({
                                                ...formData,
                                                password: event.target.value
                                            });
                                        }}
                                        endAdornment={ <CInputAdornment position="end">
                                            <CIconButton
                                                aria-label="toggle password visibility"
                                                onClick={()=>setShowPassword(!showPassword)}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                                            </CIconButton>
                                        </CInputAdornment>}
                                    />
                                </CFormControl>
                                <CGridContainer>
                                    {
                                        isSubmitting ? <CCircularProgress/> :
                                            <CButton disabled={isSubmitting} size="medium" variant="contained"
                                                     onClick={() => submit()}>
                                                Login
                                            </CButton>
                                    }
                                    {/*<div style={{flex: 1}}/>*/}
                                    {/*<CButton>*/}
                                    {/*    Forgot Password?*/}
                                    {/*</CButton>*/}
                                </CGridContainer>

                            </CCardContent>
                        </CCard>
                    </CContainer>
                </main>
            </>
        );
    }
)
